<template>
  <transition-group
    tag="div"
    :css="false"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @leave="onLeave"
  >
    <slot/>
  </transition-group>
</template>

<script>
  import gsap from 'gsap'

  export default {
    name: 'StaggeringListTransitions',
    props: {
      noLeaveDelay: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onBeforeEnter (el) {
        el.style.opacity = 0
        el.style.maxHeight = 0
      },
      onEnter (el, done) {
        gsap.to(el, {
          opacity: 1,
          maxHeight: '10000px',
          delay: el.dataset.index * 0.15,
          onComplete: done,
        })
      },
      onLeave (el, done) {
        gsap.to(el, {
          opacity: 0,
          height: 0,
          delay: this.noLeaveDelay ? 0.15 : el.dataset.index * 0.15,
          onComplete: done,
        })
      },
    },
  }
</script>

<style scoped lang="less">

</style>
